import { z } from 'zod';
import { addressSchema } from '@area-restrita/client';

export const companyAddressSchema = addressSchema;

export type ICompanyAddressFormSchema = z.infer<typeof companyAddressSchema>;
